<template>
    <div>
        <page-title heading="Detail Stok Obat" :breadcrumb="[
          {
            label: 'Manajamen Stok',
            link: '/stok',
          },
          {
            label: 'Tambah Stok Obat & BHP',
            active: true,
          },
        ]" class="layout gantung ninja-shadow" />

        <div id="tambahStokObat" class="container-fluid ">
            <div class="card card-box mb-3 ninja-shadow __zoom_display">
                <div class="card-body">
                    <b-row>
                        <b-col md="12">
                            <b-row>
                                <b-col md="6">
                                    <div class="d-flex align-items-center" style="width: 100%;">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Nama Obat</label>
                                        </div>
                                        <div style="width: 72%">
                                            <vue-select-clearable id="medicineOpt" style="font-size: 13px"
                                                :options="medicineOpt" v-model="layanan.layanan_id" disabled
                                                placeholder="Pilih Obat">
                                            </vue-select-clearable>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Stok Saat Ini</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.stock" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="align-items-center mt-4" style="width: 100%;" :class="{'d-none': !isAddStock, 'd-flex': isAddStock}">
                                        <div style="width: 28%">
                                            <label class="mb-md-0 required">Stok Masuk</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'number'" min="0" v-model="layanan.stock_in"
                                                :class="{'is-invalid' : layanan.errorStockIn}"
                                                v-on:keydown.188.capture.prevent.stop
                                                v-on:keydown.190.capture.prevent.stop
                                                @keyup="checkStockValue($event.target.value)"
                                                @click="checkStockValue($event.target.value)"
                                                :readonly="isAddStock ? false : true">
                                            </b-input>
                                            <div class="text-danger" :class="{'d-none' : !layanan.errorStockIn}">
                                                {{layanan.errorStockInMsg}}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Total Stok</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.total_stock" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id && layanan.layanan_id.kfa">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Bentuk Sediaan</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.bentuk_sediaan" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Satuan</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" :value="layanan.satuan_name || (layanan.layanan_id && layanan.layanan_id.satuan_name)" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id && layanan.layanan_id.kfa">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Golongan Obat</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.golongan_obat" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id && layanan.layanan_id.kfa">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Kategori Obat</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.kategori_obat" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Jenis Obat</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.jenis_obat" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                </b-col>
                                
                                <b-col md="6">
                                    <!-- <div class="align-items-center" style="width: 100%;" :class="{'d-none': !isAddStock, 'd-flex': isAddStock}">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Total Stok</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.total_stock" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div> -->
                                    
                                    <!-- Additional fields that show before catatan -->
                                    <div class="d-flex align-items-center mt-3 mt-xl-0" style="width: 100%;" v-if="layanan.layanan_id && layanan.layanan_id.kfa">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Komposisi</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.komposisi" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center" :class="layanan.layanan_id && layanan.layanan_id.kfa ? 'mt-4': 'mt-4 mt-xl-0'" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Route</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" :value="layanan.route" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id && layanan.layanan_id.kfa">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Manufactur</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.manufactur" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Obat BPJS</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.obat_bpjs" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id && layanan.layanan_id.kfa">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">HET</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" :value="format_money(layanan.het)" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Harga Beli</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" :value="format_money(layanan.harga_beli)" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Margin</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" :value="format_money(layanan.margin)" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;" v-if="layanan.layanan_id">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Harga Jual</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" :value="format_money(layanan.tarif)" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex mt-4" style="width: 100%;">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Catatan</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-form-textarea id="textarea" v-model="layanan.note"
                                                :readonly="isAddStock ? false : true" placeholder="Input catatan pendukung...."
                                                rows="3" max-rows="6">
                                            </b-form-textarea>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button variant="danger" class="mr-3" @click="cancelEdit()">
                        Keluar
                    </b-button>
                    <b-button variant="primary" @click="isAddStock ? saveStock() : addStock()"
                        :disabled="isAddStock ? (layanan.errorRow ? true : false) : false">
                        {{ isAddStock ? 'Simpan' : 'Tambah Stok' }}
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    components: {
        "vue-select-clearable": () => import("@/components/VueSelectClearable.vue")
    },
    data() {
        return {
            medicineOpt: [],
            satuanOpt: [],
            layananId: this.$route.params.id,
            layanan: {
                layanan_id: '',
                satuan_id: '',
                kode: '',
                nama: '',
                stock: '',
                stock_in: 0,
                total_stock: 0,
                note: "",
                errorStockIn: false,
                errorStockInMsg: "",
                errorRow: true,
                // Additional fields to show when nama obat is selected
                bentuk_sediaan: null,
                satuan_name: null,
                golongan_obat: null,
                kategori_obat: null,
                jenis_obat: null,
                komposisi: null,
                route: null,
                manufactur: null,
                obat_bpjs: null,
                het: null,
                harga_beli: 0,
                margin: 0,
                tarif: 0
            },
            isAddStock: false
        }
    },
    computed: {
        ...mapGetters(["getKlinikId"])
    },
    created() {
        // this.getDetailLayanan();
        this.getMedicineOption();
    },
    methods: {
        async getSatuanOpt() {
            let path = `klinik/satuan/list`;
            let response = await this.$axios.get(path);

            this.satuanOpt = response.data.data;
        },
        async getMedicineOption() {
            let path = `klinik/obat/list?klinik_id=${this.getKlinikId}&type=obat`;
            let response = await this.$axios.get(path);

            this.medicineOpt = response.data.data;
            await this.getDetailLayanan();
            await this.getSatuanOpt();
            let selectedObat = this.medicineOpt.find(item => item.value == this.layananId)
            let selectedSatuan = this.satuanOpt.find(item => item.value == this.layanan.satuan_id)
            this.layanan.layanan_id = selectedObat;
            this.layanan.satuan_id = selectedSatuan;
        },
        async getDetailLayanan() {
            let path = `klinik/stock/${this.layananId}`

            let response = await this.$axios.get(path);
            const responseData = response.data.data;
            
            // Set the basic stock information
            this.layanan = { 
                ...this.layanan, 
                ...responseData 
            };
            
            // Set the note and stock defaults if not present
            this.layanan.note = this.layanan.note || '-' 

            // Set additional fields from the nested layanan object and kfa data
            if (responseData.layanan) {
                const layananData = responseData.layanan;
                
                // Set values from the layanan object
                this.layanan.kode = layananData.kode;
                this.layanan.nama = layananData.nama;
                this.layanan.stock = layananData.stock || 0
                
                // Set values from the kfa object if available
                if (layananData.kfa) {
                    this.layanan.bentuk_sediaan = layananData.kfa.satuan;
                    this.layanan.golongan_obat = layananData.kfa.drug_clasification;
                    this.layanan.komposisi = layananData.kfa.komposisi;
                    this.layanan.manufactur = layananData.kfa.manufacturer;
                    this.layanan.het = layananData.kfa.het_price;
                    this.layanan.kategori_obat = layananData.kfa.generik_label;
                }
                
                // Set route if available
                if (layananData.route_obat) {
                    this.layanan.route = `${layananData.route_obat.jenis_route} (${layananData.route_obat.kategori})`;
                }
                
                // Set jenis obat if available
                if (layananData.jenis_obat) {
                    this.layanan.jenis_obat = layananData.jenis_obat.name;
                }
                
                // Set BPJS status
                this.layanan.obat_bpjs = layananData.is_bpjs === 1 ? "Ya" : (layananData.is_bpjs === 0 ? "Tidak" : null);
                
                // Set other financial data
                this.layanan.harga_beli = layananData.harga_beli;
                this.layanan.margin = layananData.margin;
                this.layanan.tarif = layananData.tarif;
                this.layanan.satuan_name = layananData.satuan_name || (layananData.satuan && layananData.satuan.name);
            }
        },
        checkStockValue(value) {
            let val = /[-.,]/.test(value) || isNaN(value) || value == "" ? 0 : parseInt(value);
            this.layanan.stock_in = val;
            this.layanan.total_stock = val + parseInt(this.layanan.stock);

            if (!val) {
                this.layanan.errorStockIn = true;
                this.layanan.errorRow = true;
                this.layanan.errorStockInMsg = "Obat masuk harus diisi";
            } else {
                this.layanan.errorStockIn = false;
                this.layanan.errorRow = false;
                this.layanan.errorStockInMsg = "";
            }
        },
        cancelEdit() {
            this.$swal({
                title: 'Keluar',
                html: this.isAddStock
                    ? `Apakah Anda yakin untuk keluar dari halaman ini ? <br/> Data yang telah ditulis tidak akan tersimpan.`
                    : `Apakah Anda yakin untuk kembali ke halaman stok ?`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "Tidak",
                confirmButtonText: "Ya",
                width: "650px"
            }).then(async (res) => {
                if (res.value) {
                    this.$router.push({ name: 'klinik-stok-obat' })
                }
            });
        },
        addStock() {
            this.layanan.stock_in = 0;
            this.layanan.total_stock = parseInt(this.layanan.stock);
            this.isAddStock = true;
        },
        saveStock() {
            let path = `klinik/stock`;
            let data = {
                layanan_id: this.layananId,
                stock: this.layanan.stock_in,
                note: this.layanan.note,
                satuan_id: this.layanan.satuan_id ? this.layanan.satuan_id.value : 0
            }

            this.$axios.post(path, [data])
                .then((response) => {
                    this.$swal({
                        title: 'Berhasil',
                        html: 'Stok berhasil ditambahkan',
                        type: 'success'
                    })

                    this.$router.push({ name: 'klinik-stok-obat' })
                })
                .catch(error => {
                    this.$swal({
                        title: 'Gagal',
                        html: 'Stok gagal ditambahkan',
                        type: 'error'
                    })
                })
        },
        format_money(value) {
            if (!value) return "Rp 0";
            const formatter = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });

            return formatter.format(value);
        }
    }
}
</script>
<style>
.is-invalid {
    border: 1px solid red;
    border-radius: 0.29rem;
}

.required:after {
    content: " *";
    color: red;
    padding-left: 5px;
}

#tambahStokObat .__zoom_display {
    zoom: 80%;
}
</style>
